import { Model } from '@vuex-orm/core'

class CasesGame extends Model {
  static entity = 'cases-game'

  static fields() {
    return {
      id: this.string(''),
      slug: this.string(''),
      name: this.string(''),
      price: this.number(0),
      items: this.attr([]),
      imageUrl: this.string(''),
      tags: this.attr([]),
      popularity: this.number(0),
      createdAt: this.attr(),
    }
  }
}

export default CasesGame
